import { createSlice } from "@reduxjs/toolkit";

const initialState: string | null = null;

const selectSeatOrderSlice = createSlice({
  name: "selectSeatOrder",
  initialState,
  reducers: {
    setSelectSeatOrderStore: (state: string | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setSelectSeatOrderStore } = selectSeatOrderSlice.actions;

export default selectSeatOrderSlice.reducer;